import type {CSSProperties} from 'react';
import {WEDGE_TERRITORY_CARD as C} from '@territory/tokens';

export type WedgeTerritoryCardLook = 'terrcard-viewall' | 'terrcard-zoom' | 'terrcard-fit' | 'terrcard-plan';

export const isWedgeTerritoryCardLook = (look: string | undefined): look is WedgeTerritoryCardLook => look !== undefined && look.startsWith('terrcard-');

/* The four controls of the Today territory card, a fixed dark green card with the same paint in every host theme. The body font is
   the stack the prototype declares. View all is a 44px pill on a soft green wash. A zoom control is a bare 44px box in the glass
   stack. Fit is a 46px glass tile hung on the map. Plan my route is a 60px green bar with a fixed halo. None draws a transparent
   target or an anchor: each box is 44px or more each way and the legacy geometry holds. */
const BODY = "'Jost', sans-serif";

export function wedgeTerritoryCardStyle(look: WedgeTerritoryCardLook): CSSProperties {
  switch (look) {
    case 'terrcard-viewall': return {
      flexShrink: 0, whiteSpace: 'nowrap', minHeight: 44, display: 'flex', alignItems: 'center', gap: 6, padding: '0 14px', borderRadius: 999,
      background: C.viewAllBg, border: `1px solid ${C.viewAllBorder}`, color: C.viewAllInk, fontFamily: BODY, fontSize: 14, fontWeight: 700,
    };
    case 'terrcard-zoom': return {width: 44, height: 44, border: 'none', background: 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center'};
    case 'terrcard-fit': return {
      position: 'absolute', background: C.glass, zIndex: 500, top: 107, right: 10, width: 46, height: 46, borderRadius: 12,
      border: `1px solid ${C.fitBorder}`, color: C.fitInk, display: 'flex', alignItems: 'center', justifyContent: 'center',
    };
    case 'terrcard-plan': return {
      height: 60, borderRadius: 18, border: 'none', background: C.emerald, color: C.ctaInk, padding: '0 8px 0 20px', display: 'flex',
      alignItems: 'center', justifyContent: 'space-between', boxShadow: C.ctaShadow,
    };
  }
}
